import { SvgIcon } from "@mui/material"

import { ReactComponent as Speedings } from "./Icon_exces-de-vitesse.svg"

export const SpeedingsIcon = (props) => {
    return (
        <SvgIcon component={Speedings} {...props} inheritViewBox />
    )
}
